import { getSettingsDomain } from "../settings/scope";
import { GET_DEALS, GET_OUTSTANDING_OUTREACH } from "./query";

// Domain is implicit from the signed-in user (super-admin switcher included);
// it is never a caller choice.
export const apiGetDeals = async (params = {}) => {
  const domain = getSettingsDomain();
  if (!domain) return { total: 0, deals: [] };
  const client = (await import("../index")).default;
  const input = {
    domain,
    ...(params.query ? { query: params.query } : {}),
    ...(params.stage ? { stage: params.stage } : {}),
    ...(params.openOnly ? { openOnly: true } : {}),
    pagination: params.pagination || { page: 1, limit: 100 },
  };
  const result = await client.query({
    query: GET_DEALS,
    variables: { input },
    fetchPolicy: "no-cache",
  });
  return {
    total: result?.data?.deals?.total || 0,
    deals: result?.data?.deals?.deals || [],
  };
};

export const apiGetOutstandingOutreach = async (dealId) => {
  const domain = getSettingsDomain();
  if (!domain || !dealId) return null;
  const client = (await import("../index")).default;
  const result = await client.query({
    query: GET_OUTSTANDING_OUTREACH,
    variables: { domain, dealId },
    fetchPolicy: "no-cache",
  });
  return result?.data?.outstandingOutreach || null;
};
